import { createSlice } from "@reduxjs/toolkit";

export const crop_doctor_annotations = createSlice({
  name: "crp_doc_annotation",
  initialState: {
    value: {
      status: false,
      imageURL: "",
      imageName: "",
      data: [],
      scrollToPlantDisease: false,
    },
  },
  reducers: {
    imageName: (state, action) => {
      state.value.imageName = action.payload;
    },
    imageUrl: (state, action) => {
      state.value.imageURL = action.payload;
    },
    checkStatus: (state, action) => {
      state.value.status = action.payload;
    },
    AnnotationData: (state, action) => {
      state.value.data = action.payload;
    },
    scrollToPlantDiseaseSection: (state, action) => {
      state.value.scrollToPlantDisease = action.payload;
    },
  },
});

export const {
  checkStatus,
  imageUrl,
  imageName,
  AnnotationData,
  scrollToPlantDiseaseSection,
} = crop_doctor_annotations.actions;

export default crop_doctor_annotations.reducer;
